import { API_BASE_URL, SEND_OTP_ENDPOINT } from "../../../utils/API_CONSTANTS";
const SendOtp = async (rollNo, reCaptchaToken) => {
  try {
    const response = await fetch(API_BASE_URL + SEND_OTP_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        rollNo: rollNo,
        recaptcha: reCaptchaToken,
      }),
    });
 
    const data = await response.json();
    
    if (!response.ok) {
      const errorData = data; // API error response
      const error = new Error(errorData.message || "Request failed"); // Attach API error message
      error.response = { data: errorData };
      throw error;
    }

    return {
      data, // The parsed JSON data
      status: response.status, // The HTTP status code
    };
  } catch (error) {
    throw error; // Retain original error
  }
};

export default SendOtp;
